import { Modal } from '@mui/material';
import api from 'api';
import PreviewTemplate from 'components/serviceProviderForms/PreviewTemplate/PreviewTemplate';
import { useEffect, useState } from 'react';
import UploadRetainerAgreement from '../components/UploadRetainerAgreement/UploadRetainerAgreement';
import styles from './ContractTemplate.module.scss';
import stylesAgreement from '../../VisaProcess/views/Agreement/Agreement.module.scss';
import AlertMessage, { AlertObj } from 'components/common/alert';

const ContractTemplate = () => {
    const [templateOpen, setTemplateOpen] = useState<boolean>(false);
    const [retainerAgreement, setRetainerAgreement] = useState<string | null>(null);
    const [isShowingAlert, setShowingAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState<AlertObj>({ type: 'info', value: '' });

    useEffect(() => {
        setTimeout(() => {
            (async () => {
                const res = await api.resource.get('retainer_agreement');
                if (res.status === 200 || res.status === 201) {
                    const url = res.data['url'];
                    setRetainerAgreement(url);
                }
            })();
        }, 300);
    }, []);

    const handleLoadRetainerAgreement = async (textFile: File) => {
        const formData: FormData = new FormData();
        formData.append('retainer_agreement', textFile);
        // await api.resource.post('retainer_agreement', formData);
        try {
            const request = await api.resource.post('retainer_agreement', formData);
            if (request.status === 200 || request.status === 201) {
                setAlertMessage({ type: 'success', value: 'Agreement successfully uploaded!' });
                setShowingAlert(true);
            }
        } catch {
            setAlertMessage({ type: 'error', value: 'Something went wrong.' });
            setShowingAlert(true);
        }
    };

    const Alert = (
        <AlertMessage
            type={alertMessage?.type}
            text={alertMessage?.value}
            open={isShowingAlert}
            onClose={() => setShowingAlert(false)}
        ></AlertMessage>
    );

    return (
        <section className={styles.root}>
            {Alert}
            <h1 className={styles.title}>contract template</h1>
            <div className={`mb-14`}>
                <p className={`form-card-content-title`}>Template retainer agreement</p>
                <p className={`mb-1`}>
                    Upload a template of your company's standard contract or use one of our
                    templates.
                </p>
                <p
                    className={`mb-3`}
                    style={{
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        color: '#4A52BB',
                        textDecorationLine: 'underline',
                    }}
                    onClick={() => setTemplateOpen(true)}
                >
                    Click here to view our standard agreement
                </p>
                <UploadRetainerAgreement
                    src={retainerAgreement ? retainerAgreement : ''}
                    getFile={handleLoadRetainerAgreement}
                />
                <div className={styles['document-preview']}>
                    <Modal
                        sx={{ zIndex: '10000' }}
                        open={templateOpen}
                        onClose={() => setTemplateOpen(false)}
                    >
                        <div className={stylesAgreement['modal-contract-wrapper']}>
                            <div className={stylesAgreement['modal-contract']}>
                                <PreviewTemplate closePreview={() => setTemplateOpen(false)} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </section>
    );
};

export default ContractTemplate;
